<template>
  <div class="feature-landing-page">
    <Alert v-if="(apiStatus.refData.fail && !apiStatus.recordData.loading) || (apiStatus.recordData.fail && !apiStatus.refData.loading)" alertType="error" />
    <slot name="customErrorMsg"></slot>
    <slot name="icon"></slot>
    <template v-if="includeRecordHeader">
      <h1 v-if="!$slots.customHeader">{{ $route.meta.title }}</h1>
      <slot name="customHeader"></slot>
    </template>
    <ApiLoading class="api-loading" v-if="apiStatus.refData.loading" :apiError="apiStatus.refData.fail" isMemberPortal />

    <section v-if="referenceData.informationText || $slots['callOutColumn']" :class="overrideContentClass === undefined ? 'top-content fr-view' : overrideContentClass">
      <div
        :id="overrideContentId !== undefined ? overrideContentId : !!$slots['callOutColumn'] ? 'side-content-paragraph' : 'main-content-paragraph'"
        v-if="!apiStatus.refData.loading"
      >
        <div v-if="!apiStatus.refData.fail && referenceData.informationText" v-html="referenceData.informationText" />
      </div>
      <slot v-if="!apiStatus.refData.loading" name="callOutColumn"></slot>
    </section>
    <section>
      <slot v-if="!apiStatus.refData.loading && $slots.paragraphData" name="paragraphData"></slot>
      <div class="filter-header"><slot v-if="$slots.filterHeader" name="filterHeader"></slot></div>
      <ApiLoading
        class="api-loading"
        v-if="!apiStatus.refData.loading && (apiStatus.recordData.loading || apiStatus.recordData.fail)"
        :apiError="apiStatus.recordData.fail"
        isMemberPortal
      />
      <div v-if="!apiStatus.recordData.loading && !apiStatus.recordData.fail && showTable" class="records">
        <div v-if="includeFilter">
          <h2 v-if="!this.$slots.paragraphData && includeRecentHeader">Recent {{ $route.meta.title.toLowerCase() }}</h2>

          <div class="filter-group">
            <form @submit.prevent novalidate class="toggle-box">
              <div class="form-section field" v-for="(filterObj, index) in filterData.filterOptions" :key="`filter-data-${index}`">
                <FormLabel
                  v-if="filterObj.filterType === filterType.TEXT_INPUT"
                  :labelText="`${filterObj.filterHeading}`"
                  :required="false"
                  :forId="`${filterObj.filterHeading}-${index}`"
                />
                <FormInput
                  v-if="filterObj.filterType === filterType.TEXT_INPUT"
                  type="text"
                  :placeholder="`${filterObj.filterPlaceholder}`"
                  v-model="filterObj.filterResult"
                  @onEnter="onEnter"
                  :id="`filter-${filterObj.filterHeading}-${index}`"
                />
                <FormLabel
                  v-if="filterObj.filterType === filterType.DATE_INPUT"
                  :labelText="`${filterObj.filterHeading}`"
                  :required="false"
                  :forId="`${filterObj.filterHeading}-${index}`"
                />
                <FormInput
                  v-if="filterObj.filterType === filterType.DATE_INPUT"
                  type="text"
                  :placeholder="filterObj.filterPlaceholder"
                  isDateInput
                  maxlength="14"
                  v-bind:required="false"
                  v-model.lazy.trim="filterObj.filterResult"
                  @onEnter="onEnter"
                  :id="`filter-${filterObj.filterHeading}-${index}`"
                  :overrideClass="filterObj.filterResultInvalid ? 'error' : null"
                />
                <label
                  v-if="filterObj.filterType === filterType.DATE_INPUT && filterObj.filterResultInvalid && filterObj.filterResult !== '' && filterObj.filterInvalidMessage !== ''"
                  class="error"
                  :for="`filter-${filterObj.filterHeading}-${index}`"
                >
                  {{ filterObj.filterInvalidMessage }}
                </label>
                <FormLabel
                  v-if="filterObj.filterType === filterType.EVENT_DATE_INPUT"
                  :labelText="`${filterObj.filterHeading}`"
                  :required="false"
                  :forId="`${filterObj.filterHeading}-${index}`"
                />
                <FormInput
                  v-if="filterObj.filterType === filterType.EVENT_DATE_INPUT"
                  type="text"
                  :placeholder="filterObj.filterPlaceholder"
                  isEventDateInput
                  maxlength="14"
                  v-bind:required="false"
                  v-model.lazy.trim="filterObj.filterResult"
                  @onEnter="onEnter"
                  :id="`filter-${filterObj.filterHeading}-${index}`"
                  :overrideClass="filterObj.filterResultInvalid ? 'error' : null"
                />
                <label
                  v-if="
                    filterObj.filterType === filterType.EVENT_DATE_INPUT && filterObj.filterResultInvalid && filterObj.filterResult !== '' && filterObj.filterInvalidMessage !== ''
                  "
                  class="error"
                  :for="`filter-${filterObj.filterHeading}-${index}`"
                >
                  {{ filterObj.filterInvalidMessage }}
                </label>
                <FormLabel
                  v-if="filterObj.filterType === filterType.DROPDOWN_INPUT"
                  :labelText="`${filterObj.filterHeading}`"
                  :required="false"
                  :forId="`dropdown-${filterObj.filterHeading}-${index}`"
                />
                <DropdownSelect
                  v-if="filterObj.filterType === filterType.DROPDOWN_INPUT"
                  :items="getDropdownItems(filterObj.filterDropdownData)"
                  :id="`dropdown-${filterObj.filterHeading}`"
                  v-model="filterObj.filterResult"
                  :initialSelect="dropdownName(filterObj.filterDropdownData[0])"
                />
                <label
                  v-if="
                    filterObj.filterType === filterType.DROPDOWN_INPUT && filterObj.filterResultInvalid && filterObj.filterResult !== '' && filterObj.filterInvalidMessage !== ''
                  "
                  class="error"
                  :for="`filter-${filterObj.filterHeading}-${index}`"
                >
                  {{ filterObj.filterInvalidMessage }}
                </label>
              </div>

              <div class="filter-buttons">
                <div class="button-group">
                  <button type="submit" class="button" @click="applyFilters" :disabled="applyBtnDisabled">Apply</button>
                  <button type="reset" class="secondary" @click="resetFilters">Clear</button>
                </div>
              </div>
            </form>
            <!-- </vue-slide-up-down> -->
          </div>
        </div>
        <RecordsTable
          :apiStatus="apiStatus"
          :recordsData="recordsData"
          :initialData="initialData"
          :linkColumn="linkColumn"
          :recordLink="recordLink"
          :isFilterApplied="isFilterApplied"
          :crmNavigatePage="crmNavigatePage"
          :crmNavigateParams="crmNavigateParams"
          :defaultNoData="defaultNoData"
          :haveMinHeight="haveMinHeight"
          :dropDownColumn="dropDownColumn"
          :dropDownList="dropDownList"
          @recordDataChanged="recordDataChanged"
        >
          <template #tableTop>
            <slot name="paginationLabel"></slot>
            <div :class="quickNavAlignment === QuickNavLinksAlignment.LEFT ? 'top-additional-content' : 'top-additional-content-fr'">
              <slot name="resultsLabel"></slot>
              <slot name="quickNavLinks"></slot>
            </div>
          </template>
          <template #tableBottom>
            <p v-if="isFilterApplied && recordsData.data.length === 0 && recordsData.headings.length !== 0" class="message">
              {{ filterData.filterNoRecordsText || 'Sorry, there is no result found.' }}
            </p>
          </template>
          <template #tablePagination>
            <slot name="pagination"></slot>
          </template>
        </RecordsTable>
        <slot name="additionalTables"></slot>
        <slot name="preFooter"></slot>
        <div v-if="isExternalLink && apiStatus.recordDocument && apiStatus.recordDocument.loading" class="modal-screen" aria-label="submitting your query.">
          <div class="modal" role="dialog">
            <ApiLoading
              v-if="apiStatus.recordDocument.loading"
              :apiError="false"
              class="submit-loading"
              loadingMessage="We are processing your request. It shouldn't be too long."
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { Alert, ApiLoading, FormInput, FormLabel, RecordsTable } from '@/components';
import { FilterTypes, QuickNavLinksAlignment } from '@/enums';
import { isBuildCRM } from '@/utils';
import { isEmptyString } from '@general/js/utils/StringTransformUtils';
import DropdownSelect from '@general/js/components/DropdownSelect.vue';

const isCRM = isBuildCRM();

export default {
  name: 'RecordsView',

  components: {
    Alert,
    ApiLoading,
    FormInput,
    FormLabel,
    RecordsTable,
    DropdownSelect,
  },

  props: {
    /**
     * Holds api status for data gathered from api calls
     * Contains properties that contain 'fail and 'loading' properties:
     * - refData
     * - recordData
     * - recordDocument (not always included)
     */
    apiStatus: {
      type: Object,
      required: true,
    },

    /**
     * Holds information on all records for table
     * Contains the following properties:
     * - headings: List of headings for table
     * - data: List of objects containing data
     * - noRecordsText: text for when there are no records available
     * - colSetting: The column settings for things like width. Currently only supports width.
     * - colAlignments: An array holding the text alignments for each col in the table
     * e.g. headings = ['Number', ''Member', 'Date']
     *      data = [{Number: 2, Member: 'AA', Date: 01/02/2003}, {Number: 1 ...}]
     *      noRecordsText = 'No records'
     *      colSetting = [{width: '20px'}]
     *      colAlignments = ['left', 'left', 'left', 'right', 'right', 'right']
     */
    recordsData: {
      type: Object,
      required: true,
    },
    /**
     * Reference data for page content, contains properties:
     * - informationText: main page content
     * - callOutText: extra call out content
     */
    referenceData: {
      type: Object,
      required: true,
    },
    styleClass: {
      type: String,
      default: '',
    },
    /**
     * If the Record data (first column) is an external link
     * If external link, it will run the recordLinkFunction (prop)
     * If not external link, it will run router-view to send to internal page
     */
    isExternalLink: {
      type: Boolean,
      default: false,
    },
    /**
     *  Whether the page includes a filter or not
     */
    includeFilter: {
      type: Boolean,
      default: false,
    },
    /**
     * Object contains
     * - filterName,
     * - filter function (filterFunction)
     * - filterOptions (contains objects). Each filterOptions object contains:
     *    - filterHeading: Heading of filter (always required)
     *    - filterType: Type of filter (text, date, dropdown) (always required)
     *    - filterPlaceHolder: placeholder text (always required)
     *    - filterResult: resulting filter data (always required)
     *    - filterResultInvalid: true if result is invalid (used for date validation)
     *    - filterDropdownData: list of dropdown data (only required for dropdown)
     * - filterNoRecordsText: text to display for no records found in filtering (optional),
     */
    filterData: {
      type: Object,
    },

    recordLink: {
      recordLinkFunction: {
        type: Function,
      },

      // Use to decide which parameters need to be returned within recordLinkFunction
      recordLinkParams: {
        type: String,
      },
    },

    /**
     * Alignment of quick navigation links. Values are either 'left' or 'right'
     */
    quickNavAlignment: {
      type: String,
      default: QuickNavLinksAlignment.LEFT,
    },

    /**
     * Number to set a column of the table to be links. The number will be an index starting from 0 (for first column)
     */
    linkColumnValue: {
      type: Number,
      default: 0,
    },

    /**
     * Whether the page is CRM or not
     */
    isCRM: {
      type: Boolean,
      default: isCRM,
    },

    /**
     * CRM Navigate function parameters
     */
    crmNavigateParams: {
      type: Object,
    },

    /**
     * Allows for hiding table data
     */
    showTable: {
      type: Boolean,
      default: true,
    },

    /**
     * optional, used to check the change of recordsData.data
     */

    initialData: {
      type: Array,
    },

    /**
     * Spaces should default to either -- or blank space
     */
    defaultNoData: {
      type: String,
      default: '&#8212;',
    },

    /**
     * Allows the table that is presented to have a minimum height.
     */
    haveMinHeight: {
      type: Boolean,
      default: false,
    },

    /**
     * Allows showing / hiding main record header.
     */
    includeRecordHeader: {
      type: Boolean,
      default: true,
    },

    /**
     * Allows showing / hiding recent header. To disable this completely, paragraphData slot should be empty
     */
    includeRecentHeader: {
      type: Boolean,
      default: true,
    },

    /**
     * Allows showing / hiding top alert irregardless of apiStatus
     */
    includeTopAlert: {
      type: Boolean,
      default: true,
    },

    /**
     * Overrides top paragraph content section class
     */
    overrideContentClass: {
      type: String,
    },

    /**
     * Overrides top paragraph content id
     */
    overrideContentId: {
      type: String,
    },

    /**
     * Allows disabling apply button when filter is invalid
     */
    disableApplyOnInvalidFilter: {
      type: Boolean,
      default: false,
    },

    dropDownColumn: {
      type: Object,
    },

    dropDownList: {
      type: Object,
      // Dropdown list item which will be set as disabled, optional
      disabledItem: {
        type: String,
      },
      // Each item in this array has name and value properties
      dropDownItems: {
        type: Array,
      },
    },
  },

  data() {
    return {
      filterIsToggled: false,
      filterActive: false,
      filterType: FilterTypes,
      linkColumn: {
        index: this.linkColumnValue, // First column will be a link
        isExternalLink: this.isExternalLink,
        isCRM: this.isCRM,
      },
      isFilterApplied: false,
      QuickNavLinksAlignment,
    };
  },

  watch: {
    filterData: {
      handler() {
        this.updateFilterData();
      },
      deep: true,
    },
    'filterData.filterName': function () {
      // reset filter if the parent class changes (when moved to new page)
      this.filterIsToggled = false;
      this.filterActive = false;
    },
  },

  computed: {
    applyBtnDisabled() {
      if (this.disableApplyOnInvalidFilter) {
        return this.filterData.filterOptions.some((item) => {
          return item.filterResultInvalid;
        });
      }
      return false;
    },
  },

  methods: {
    toggle() {
      this.filterActive = !this.filterActive;
      this.filterIsToggled = !this.filterIsToggled;
    },
    resetFilters() {
      this.filterData.filterOptions.forEach((item) => {
        if (item.filterType === FilterTypes.DROPDOWN_INPUT && item.filterDropdownData) {
          if (!item.filterPlaceholder) {
            item.filterResult = this.dropdownValue(item.filterDropdownData[0]) ?? this.dropdownName(item.filterDropdownData[0]);
          } else {
            item.filterResult = '';
          }
        } else {
          item.filterResult = '';
        }
      });
      this.updateFilterData();
      this.filterData.filterFunction();
      this.isFilterApplied = false;
    },
    onEnter() {
      this.filterData.filterFunction();
    },
    updateFilterData() {
      this.$emit('updatedFilterData', this.filterData);
    },
    applyFilters() {
      this.filterData.filterFunction();
      this.isFilterApplied = true;
    },
    dropdownValue(dropdownData) {
      // Check if the dropdown data is an object
      if (dropdownData && typeof dropdownData !== 'string' && Object.keys(dropdownData).length > 0) {
        return dropdownData.value;
      }

      return dropdownData;
    },
    dropdownName(dropdownData) {
      // Check if the dropdown data is an object
      if (dropdownData && typeof dropdownData !== 'string' && Object.keys(dropdownData).length > 0) {
        return dropdownData.name;
      }

      return dropdownData;
    },
    // if there is no available value for dropdown option, return the name
    getDropdownDisplayValue(dropdownData) {
      return isEmptyString(this.dropdownValue(dropdownData)) ? this.dropdownName(dropdownData) : this.dropdownValue(dropdownData);
    },

    getDisplayValue(filterObj) {
      let displayValue;
      // Work out whether the filter drop down data is an object with name and value, or whether it's just an array of strings
      if (
        filterObj.filterDropdownData.every((dropDownItem) => {
          return typeof dropDownItem === 'string';
        })
      ) {
        displayValue = filterObj.filterResult;
      } else {
        // Assume that it will be an object that has name and value
        const selectedItem = filterObj.filterDropdownData.find((dropDownItem) => {
          return dropDownItem.value === filterObj.filterResult;
        });

        displayValue = selectedItem ? selectedItem.name : null;
      }

      if (displayValue === '' || displayValue == null) {
        displayValue = filterObj.filterPlaceholder;
      }

      return displayValue;
    },

    // Returns an array of dropdown values in the format that is required for the DropdownSelect component
    getDropdownItems(dropdownData) {
      return dropdownData.map((item) => {
        return {
          value: this.dropdownValue(item),
          name: this.dropdownName(item),
        };
      });
    },

    /**
     * emit data to parent for page navigation in CRM.
     *
     * @param {string} targetPageName name of target page. it should be one of `PAGES` object value.
     * @param {object} routeParams by default is empty object. if given, it should be object. this object will be used like route param in non CRM build.
     */
    crmNavigatePage(targetPageName, routeParams = {}) {
      window.scrollTo(0, 0);
      this.$emit('crmNavigatePage', targetPageName, routeParams);
    },

    recordDataChanged(obj) {
      this.$emit('recordDataChanged', obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-content {
  @include flex-row;
  column-gap: 56px;
  margin: 4.5rem 0;

  @include mobile {
    flex-direction: column;
    margin: 2.5rem 0;
  }
}

.filter-header {
  & > * {
    margin-bottom: rem(12);
  }
}

.records {
  margin-bottom: 1.5rem;

  .filter-group {
    margin-bottom: spacer(2);
    position: relative;

    .toggle-arrow {
      position: relative;
      color: $GREY_800;
      text-decoration: none;
      margin: 0;
      padding: spacer(1.8) spacer(2);
      display: block;
      font-size: 1.25rem;
      max-width: 100%;
      width: 100%;
      background: transparent;
      box-shadow: none;
      height: 65px;
      line-height: $BASE_LINE_HEIGHT;
      text-align: left;

      &:after {
        content: '';
        width: 32px;
        height: 32px;
        position: absolute;
        top: 16px;
        right: 14px;
        background-image: url('/assets/public/images/icon_collapsed.svg');
        background-repeat: no-repeat;
        transition: 0.3s all ease-in;
        cursor: pointer;
        background-size: 20px 20px;
        background-position: 50% 50%;
      }

      &.toggled:after {
        transform: rotate(90deg);
      }

      @include mobile {
        font-size: 1.11803rem;
      }

      // Add default browser outline for accessibility
      &:focus {
        outline: 1px dotted $BLACK;
        outline: 5px auto -webkit-focus-ring-color;
      }
    }

    .toggle-box {
      @include flex-row;
      column-gap: 1rem;
      flex-wrap: wrap;

      & > div:not(.filter-buttons) {
        flex: 1;
        min-width: 200px;
        margin-bottom: spacer(2);

        &:nth-last-child(2) {
          margin-bottom: 0;

          &:after {
            content: '';
            flex: auto;
          }
        }
      }

      .form-section {
        @include mobile {
          margin-bottom: 0.25rem;
        }

        .error {
          position: absolute;
        }

        input.error {
          position: relative;
        }
      }

      select + label {
        height: auto;
      }

      @include mobile {
        @include flex-col;

        & > div:not(.filter-buttons) {
          width: 100%;
          margin-right: 0;
        }
      }

      .date-range-picker {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        & > div {
          width: calc(50% - 2.5px);
        }

        p {
          margin: 2px 0;
          color: $ERROR;
          font-size: 0.75rem;
        }
      }

      .filter-buttons {
        text-align: right;
        margin-top: spacer(1.5);
        margin-left: auto;
        min-width: 450px;
        grid-column: span 2;
        grid-column-end: -1;

        button {
          margin-left: 20px;
          max-height: 50px;
        }

        @include mobile {
          width: 100%;
          min-width: unset;
          margin-top: spacer(2);

          .button-group {
            @include flex-col;
            gap: 4px;
          }

          button {
            margin-left: 0;
            max-height: 50px;
            display: block;
            width: 100%;
            max-width: unset;
          }
        }
      }
    }

    button {
      height: 100%;
    }
  }
}

.records {
  .records-list {
    .pagination-container {
      @include mobile {
        margin-top: 30px;
      }
    }
  }
}

.submit-loading {
  background: $WHITE;
  min-height: unset;
}

.top-additional-content {
  width: 100%;

  @include mobile {
    margin-top: spacer(1);
  }

  :deep(.quick-nav-links) {
    display: flex;
    min-width: 180px;
    column-gap: spacer(3);

    @include mobile {
      display: block;
      text-align: left;

      li {
        margin-bottom: spacer(1);
      }
    }
  }
}

.top-additional-content-fr {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  margin-bottom: rem(50);

  @include mobile {
    grid-template-columns: auto;
    margin-bottom: 0;
  }

  :deep(.quick-nav-links) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    column-gap: 5px;
    min-width: 180px;

    @include mobile {
      display: block;
      text-align: left;
    }
  }
}

:deep(.dropdown-face > input) {
  padding: 0.75rem 2.5rem 0.75rem 1rem !important;
}
</style>
